import { put } from 'redux-saga/effects';
import PropertyActions from './PropertyRedux';
import API from '@utils/api';
import logger from '@utils/logger';

export function* loadAllProperties() {
  try {
    yield put(PropertyActions.setPropertiesLoading(true));
    const { result } = yield API.getProperties();

    yield put(PropertyActions.setPropertiesList(result));
    yield put(PropertyActions.setPropertiesLoading(false));
  } catch (err) {
    //TODO: notify error
    logger.error(err);
  }
}
